import { CHAT_OPEN, CHAT_CLOSE, CHAT_TOGGLE, CHAT_SET_UNREAD_COUNT } from 'store/actions/Chat/types'

const initialState = {
  isOpen: false,
  unreadCount: 0
}

const chatReducer = (state = initialState, action) => {
  switch (action.type) {
    case CHAT_OPEN:
      return {
        ...state,
        isOpen: true
      }
    case CHAT_CLOSE:
      return {
        ...state,
        isOpen: false
      }
    case CHAT_TOGGLE:
      return {
        ...state,
        isOpen: !state.isOpen
      }
    case CHAT_SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload
      }
    default:
      return state
  }
}

export default chatReducer